import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

// Breadcrumbs – visas på varje undersida, med BreadcrumbList-schema via Seo-komponenten.
export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Brödsmulor" className="border-b border-midnight/10 bg-white">
      <div className="container-tisab py-4">
        <ol className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-tisab transition-colors">
            <Home className="h-3.5 w-3.5" />
            <span className="sr-only">Hem</span>
          </Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50" />
            {i === items.length - 1 ? (
              <span className="font-medium text-foreground" aria-current="page">{item.name}</span>
            ) : (
              <Link to={item.path} className="hover:text-tisab transition-colors">{item.name}</Link>
            )}
          </li>
        ))}
        </ol>
      </div>
    </nav>
  );
}